import axios from 'axios';
import qs from 'qs';
import element from 'element-ui';
import { getLogin } from '@/common/http.js';
// 页面重载和加载
export function uniLoad (payload) {
  // console.log(payload)
  //下拉刷新  uniLoad({})
  // 刷新标识(防止进入刷新死循环)
  let preRefresh = true
  if (payload.load) {
    // console.log("方法内部", payload.pageIndex, payload.length)
    return new Promise((reslove, reject) => {
      let result = {}
      if (payload.pageIndex == 1 && payload.length == 0) {
        result = {
          msg: "初始加载数据 返回数据长度不足",
          canAdd: false
        }
      } else if (payload.pageIndex == 1 && payload.length > 0) {
        result = {
          msg: "初始加载数据",
          canAdd: true
        }
      } else if (payload.pageIndex != 1 && payload.pageSize > payload.length) {
        result = {
          msg: "累加数据 返回数据长度不足",
          canAdd: false
        }
      } else {
        result = {
          msg: "累加数据 数组长度满足",
          canAdd: true
        }
      }
      console.log(result)
      reslove(result)
    })
  } else {
    let routes = getCurrentPages(); // 获取当前打开过的页面路由数组
    let curRoute = routes[routes.length - 1].route //获取当前页面路由
    let curParam = routes[routes.length - 1].options; //获取路由参数
    // let prevRoute = routes[routes.length - 2].route //获取上一页页面路由
    // 拼接参数
    let param = ''
    for (let key in curParam) {
      param += '&' + key + '=' + curParam[key]
    }
    if (preRefresh) {
      console.log(`当前页面路径:/${curRoute}${param.replace("&", "?")}`)
      if (payload.main) {
        console.log('switchtab刷新')
        uni.reLaunch({
          url: `/${curRoute}`
        })
      } else {
        uni.redirectTo({
          url: `/${curRoute}${param.replace("&", "?")}`
        });
      }
      preRefresh = false
      setTimeout(() => {
        uni.stopPullDownRefresh()
      }, 2000)
    }
  }
}

const token = localStorage.getItem('token');
const cookie = localStorage.getItem('cookie')
// 统一请求发起
export function uniRequest (url, payload, methods = "get", form) {
  let method = ""
  if (methods == "get") {
    method = "GET"
  } else if (methods == "post") {
    method = "POST"
  } else if (methods == "delete") {
    method = "DELETE"
  } else {
    method = "PUT"
  }
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }

  if (cookie) {
    headers.Cookie = cookie
  }
  if (token) {
    headers.token = token
    // headers['Access-Control-Allow-Headers'] = 'Content-Type,Access-Token,token'
  }
  let parms = {
    ...payload
  }
  let config = {
    url: url,
    method: method,
    headers: headers
  }
  return new Promise((reslove, reject) => {
    let login = checkStatus(url)
    if (method == 'GET') {
      config.params = parms ? parms : null
    } else {
      config.data = parms ? qs.stringify(parms) : null
    }

    if (login) {
      axios(config).then((result) => {
        if (result.data.result) {
          reslove(result.data)
        } else {
          reslove(result)
        }
      }).catch((result) => {
        reject(result)
      })
    }

  })
}

// (比较token用于自动登录)
function resetToken (res) {
  let token = localStorage.getItem('token');
  // console.log(token,'本地储存的token值')
  // 本次请求状态码为200并且返回的header里有token属性 条件一
  let result = (res.status == 200 && res.config.headers.token)
  // 满足条件一后  本地token不等于请求回来的token重新设置本地token值
  let justifty = (res.config.headers.token != token)
  result ? justifty ? localStorage.setItem('token', res.config.headers.token) : '' : ''
}

function getProfit (methods, url, result) {
  let level = localStorage.getItem('level')
  let rank = localStorage.getItem('rank')
  if (methods == "get" && (url.indexOf('/-goods.htm') != -1 || url.indexOf('/-homepage/substance/s.htm') != -1)) {
    if (level == 1) {
      let priceList = []
      // 返利率(默认线上餐饮 level 1 type:15 的返利)
      let rate = 0.08
      if (result.data.data.pList) {
        result.data.data.pList.map((item, index) => {
          switch (rank) {
            case 1:
              if (item.type == 1) {
                if (item.secondaryclassification == 491) {
                  rate = 0.07
                } else if (item.secondaryclassification == 492) {
                  rate = 0.02
                } else if (item.secondaryclassification == 493) {
                  rate = 0.05
                } else if (item.secondaryclassification == 494) {
                  rate = 0.15
                } else if (item.secondaryclassification == 495) {
                  rate = 0.15
                } else if (item.secondaryclassification == 496) {
                  rate = 0.15
                }
              } else if (item.type == 15) {
                rate = 0.08
              } else if (item.type == 20) {
                rate = 0.05
              } else if (item.type == 35) {
                rate = 0.05
              } else if (item.type == 40) {
                rate = 0.05
              }
              break;
            case 2:
              if (item.type == 1) {
                if (item.secondaryclassification == 491) {
                  rate = 0.11
                } else if (item.secondaryclassification == 492) {
                  rate = 0.025
                } else if (item.secondaryclassification == 493) {
                  rate = 0.07
                } else if (item.secondaryclassification == 494) {
                  rate = 0.2
                } else if (item.secondaryclassification == 495) {
                  rate = 0.2
                } else if (item.secondaryclassification == 496) {
                  rate = 0.2
                }
              } else if (item.type == 15) {
                rate = 0.1
              } else if (item.type == 20) {
                rate = 0.07
              } else if (item.type == 35) {
                rate = 0.07
              } else if (item.type == 40) {
                rate = 0.07
              }
              break;
            case 3:
              if (item.type == 1) {
                if (item.secondaryclassification == 491) {
                  rate = 0.15
                } else if (item.secondaryclassification == 492) {
                  rate = 0.05
                } else if (item.secondaryclassification == 493) {
                  rate = 0.1
                } else if (item.secondaryclassification == 494) {
                  rate = 0.25
                } else if (item.secondaryclassification == 495) {
                  rate = 0.3
                } else if (item.secondaryclassification == 496) {
                  rate = 0.3
                }
              } else if (item.type == 15) {
                rate = 0.13
              } else if (item.type == 20) {
                rate = 0.1
              } else if (item.type == 35) {
                rate = 0.1
              } else if (item.type == 40) {
                rate = 0.1
              }
              break;
          }
          priceList.push(Number(item.price * rate).toFixed(2))
        })
        priceList.map((item, index) => {
          result.data.data.pList[index].priceRule = item
        })
      }

      return result
    }
  }
}

function checkStatus (url) {
  let condition = url.indexOf('/user')
  // 获取保存的用户信息
  const userInfo = localStorage.getItem('userInfo')
  const token = localStorage.getItem('token')
  return authTip(condition, url, userInfo, token)
}

function authTip (condition, url, userInfo, token) {
  if (condition != -1) {
    // console.log('进入了user接口')
    //分两种情况
    //当本地信息为空的时候，重定向到授权登录
    if (!userInfo || !token) {

      //请求的用户信息
      if (url.indexOf('/user/-a-order-store') != -1) {
        console.log('该页面仅供登录用户查看', url)


      } else if (
        url.indexOf('/user/-collection/collection-store-judge') == -1 &&
        url.indexOf('/user/-collection/collection-goods-judge') == -1 &&
        url.indexOf('/user/-my-findaddress.htm') == -1 &&
        url.indexOf('/user/-my-findaddress.htm') == -1) {
        console.log('进入登录提示', url)
        // 提示该功能需要用户登录 跳转登录
        return true
      }
      return false
    } else {
      return true
    }
  } else {
    // console.log('没进入了user接口')
    return true
  }

}

// 正则检验
export function validate (type, val) {
  // 手机正则
  const phoneReg = /^1[3456789]\d{9}$/
  switch (type) {
    case "phone":
      return phoneReg.test(val)
      break;
  }
}
export function getLocation () {
  return new Promise((reslove, reject) => {
    uni.getLocation({
      type: 'wgs84',
      geocode: true, //设置该参数为true可直接获取经纬度及城市信息
      success: function (res) {
        console.log('获取当前位置', res)
        reslove(res)
      },
      fail: function (erro) {
        uni.showToast({
          title: '获取地址失败，将导致部分功能不可用',
          icon: 'none'
        });
        reject(erro)
      }
    });
  })
}

function LoginToken (status) {
  // const justifty = localStorage.getItem("LoginToken")
  // if (!justifty) {
  // if (status == "UNAUTHORIZED") {
  // if (status == 617) {
  // let obj = JSON.parse(localStorage.getItem("account"));
  // if(obj){
  // getLogin({
  // 	password: obj.password,
  // 	phone: obj.phone
  // }).then(res => {
  // 	if (res.result) {
  // 		localStorage.setItem('userInfo', JSON.stringify(res.data.user));
  // 		localStorage.setItem('userExt', JSON.stringify(res.data.userExt));
  // 		localStorage.setItem('token', res.data.token);
  // 		location.reload()
  // 		localStorage.setItem("LoginToken", true)
  // 	} else {
  // 		localStorage.setItem("LoginToken", false)
  // 	}
  // })
  // }else{
  localStorage.clear();
  element.MessageBox('当前用户信息已过期，请重新登录', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    window.location.href('/');
    $('.login-eject').fadeIn();
  }).catch(() => {
  });
  // }
  // }
  localStorage.setItem("LoginToken", true)
  setTimeout(() => {
    localStorage.setItem("LoginToken", false)
  }, 500)
  // }
}

// 时间格式化
export function dateFormat (time, format = "MM月DD日", needWeek = false) {
  if (needWeek) {
    let week = moment(time).day()
    switch (week) {
      case 1:
        return '周一'
      case 2:
        return '周二'
      case 3:
        return '周三'
      case 4:
        return '周四'
      case 5:
        return '周五'
      case 6:
        return '周六'
      case 0:
        return '周日'
    }
  } else {
    return moment(time).format(format)
  }
}

export function myUploadRequest (url, filePath, data, count) {
  if (count >= 0) {
    uni.showLoading({
      title: '加载中',
      mask: true
    });
  }
  let header = {}
  let token = localStorage.getItem('token')
  let cookie = localStorage.getItem('cookie')
  if (cookie) {
    header.Cookie = cookie
  }
  if (token) {
    header.token = token
  }

  let promise = new Promise(function (resolve, reject) {
    uni.uploadFile({
      url: url,
      filePath: filePath,
      name: 'file',
      header: header,
      formData: data,
      success: function (res) {
        // console.log('上传',res)
        // if (res.header['token']) {
        // 	wx.setStorageSync('token', res.header['token'])
        // }
        // if (res.header['Set-Cookie']) {
        // 	let c = res.header['Set-Cookie'];
        // 	c = c.substring(0, c.indexOf(';'));
        // 	wx.setStorageSync('cookie', c)
        // }
        // if (count === 0) {
        // 	uni.hideLoading();
        // }
        //接口调用成功
        res = JSON.parse(res.data)
        if (res.result) {
          resolve(res); //根据业务需要resolve接口返回的json的数据
        } else {
          if (count && count >= 0) {
            uni.hideLoading();
          }
          uni.showToast({
            title: res.msg,
            icon: 'none'
          });
          resolve(res)
        }
      },
      fail: function (res) {
        if (count >= 0) {
          uni.hideLoading();
        }
        // fail调用接口失败
        reject({
          errormsg: '网络错误,请稍后重试',
          code: -1
        });
      }
    })
  });
  return promise; //注意，这里返回的是promise对象
}

// 处理多次点击
export function dianji (fn) {
  let that = this;
  if (that.onoff) {
    that.onoff = false;
    fn();
    setTimeout(function () {
      that.onoff = true;
    }, 1500)
  } else {
    //如果一直走else分支可能是你没有在页面的data下面挂载onoff:true,不然一直都会走else
    uni.showToast({
      title: '重复点击,请稍后重试',
      icon: 'none'
    })
  }
}

//功能：计算两个时间戳之间相差的日时分秒
export function getCutDown (value) {
  //注：不论安卓还是ios，请将时间如 2020-02-02 20:20:20 转化为 2020/02/02 20:20:20 这种形式后再使用，否则无法转换，如下转换即可↓
  let transedPreTime = value.replace(/-/g, '/') //这里转化时间格式为以/分隔形式
  let nowTime = new Date().getTime();
  let preTime = new Date(transedPreTime).getTime()
  let obj = null;
  if (preTime - nowTime > 0) {
    let time = (preTime - nowTime) / 1000;
    let day = parseInt(time / (60 * 60 * 24));
    let hou = parseInt(time % (60 * 60 * 24) / 3600);
    let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
    let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
    let hours = hou + (day * 24);
    obj = {
      // day: day<10?'0'+day:day,
      hour: hours < 10 ? '0' + hours : hours,
      min: min < 10 ? '0' + min : min,
      second: sec < 10 ? '0' + sec : sec
    };
    // this.liveCountdown = obj.day + '天' + obj.hou + '时' + obj.min + '分' + obj.sec + '秒';
    return obj
  } else {
    obj = {
      hour: '00',
      min: '00',
      second: '00'
    };
    // this.liveCountdown = obj.day + '天' + obj.hou + '时' + obj.min + '分' + obj.sec + '秒';
    return obj
  }
}

// 时间转换
export function timeago (t) {
  var date = t;
  date = new Date(Date.parse(date.replace(/-/g, "/")));
  var date_get = date.getTime();
  var date_cur = new Date().getTime()
  var ttime01 = (date_cur - date_get) / 1000;
  var ttime = "";
  if (ttime01 <= 60) {
    ttime = "刚刚";
  } else if ((ttime01) / 60 > 1 && (ttime01) / 60 <= 60) {
    ttime = Math.round((ttime01) / 60) + '分钟前';
  } else if ((ttime01) / 60 / 60 > 1 && (ttime01) / 60 / 60 <= 24) {
    ttime = Math.round((ttime01) / 60 / 60) + '小时前';
  } else if ((ttime01) / 60 / 60 / 24 > 1 && (ttime01) / 60 / 60 / 24 <= 30) {
    ttime = Math.round((ttime01) / 60 / 60 / 24) + '天前';
  } else if ((ttime01) / 60 / 60 / 24 / 30 > 1 && (ttime01) / 60 / 60 / 24 / 30 <= 12) {
    ttime = Math.round((ttime01) / 60 / 60 / 24 / 30) + '月前';
  } else if ((ttime01) / 60 / 60 / 24 / 30 / 12 > 1) {
    ttime = Math.round((ttime01) / 60 / 60 / 24 / 30 / 12) + '年前';
  }

  return ttime;
}

// 提示框
export function message (payload) {
  element.Message({
    showClose: payload.close ? payload.close : true,
    message: payload.message,
    type: payload.type ? payload.type : 'info',
    duration: payload.duration ? payload.duration : 2000,
    offset: payload.offset ? payload.offset : 70,
  });
}



// WEBPACK FOOTER //
// ./src/common/common.js